/**
 * Cosmetic catalog (Phase 6): paints, emissive colours, stencil decals and cosmetic parts. A
 * cosmetic is free (price 0, no level), bought with credits (price > 0) or unlocked by pilot
 * level (levelUnlock set, price 0): never both. Nothing here touches the simulation.
 */
import { z } from 'zod';
const id = z.string().regex(/^[a-z][a-z0-9-]*$/);
const hex = z.string().regex(/^#[0-9a-f]{6}$/);
const base = {
    id,
    name: z.string().min(1).max(40),
    /** Credits; 0 for free and level-gated items. */
    price: z.number().int().nonnegative(),
    /** Pilot level that unlocks the item without payment; null when it is free or for sale. */
    levelUnlock: z.number().int().positive().nullable(),
};
export const COSMETIC_KINDS = ['paint', 'emissive', 'decal', 'part'];
export const PaintSchema = z.object({ ...base, kind: z.literal('paint'), hex }).strict();
export const EmissiveSchema = z.object({ ...base, kind: z.literal('emissive'), hex }).strict();
export const DecalSchema = z
    .object({
    ...base,
    kind: z.literal('decal'),
    /** Tile id in the decal atlas (`assets/processed/decals/atlas.json`). */
    tile: id,
})
    .strict();
export const PartSchema = z
    .object({
    ...base,
    kind: z.literal('part'),
    /** The kit part the mech's model carries as a hidden `COSMETIC_<part>` node. */
    part: id,
    /** The one mech this item fits (parts are placed per recipe). */
    chassis: id,
})
    .strict();
export const CosmeticDefinitionSchema = z
    .discriminatedUnion('kind', [PaintSchema, EmissiveSchema, DecalSchema, PartSchema])
    .superRefine((item, ctx) => {
    if (item.levelUnlock !== null && item.price > 0) {
        ctx.addIssue({
            code: 'custom',
            message: `cosmetic "${item.id}": a level-gated item cannot also have a price`,
        });
    }
});
//# sourceMappingURL=cosmetic-schema.js.map